import { render } from "./NotFound.vue?vue&type=template&id=6ab0224a&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=6ab0224a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab0224a"]])

export default __exports__